// What a page tells its copilot through its state (key `copilot`, SPEC §5.3), read by the host without loading the copilot's conversation
// (KeptPages keeps it out of the first paint; PageCopilot loads with the first page kept). WP-SIDEBAR.

export type Bi = { en: string; ar?: string | null };

/** A page's request that the agent look at something (process-kit `askAgent`): acted on once per nonce. */
export interface PageAsk { nonce: string; prompt: string; send: boolean }

/** The starters of the current tab, a context line, an ask. */
export interface CopilotState { starters: Bi[]; context: string | Bi | null; ask: PageAsk | null }

const isBi = (x: unknown): x is Bi => !!x && typeof x === "object" && typeof (x as Bi).en === "string";

/** Reads the `copilot` key of a page's state, ignoring anything malformed: the page is untrusted, the host only takes what it expects. */
export function readCopilot(state: Record<string, unknown> | null | undefined): CopilotState {
  const c = state?.copilot as Record<string, unknown> | undefined;
  if (!c || typeof c !== "object") return { starters: [], context: null, ask: null };
  const starters = Array.isArray(c.starters) ? c.starters.filter(isBi).slice(0, 4) : [];
  const context = typeof c.context === "string" ? c.context : isBi(c.context) ? c.context : null;
  const a = c.ask as Record<string, unknown> | undefined;
  const ask = a && typeof a.nonce === "string" && typeof a.prompt === "string" && a.prompt.trim()
    ? { nonce: a.nonce, prompt: a.prompt.slice(0, 4000), send: a.send !== false }
    : null;
  return { starters, context, ask };
}
